import { useState, useEffect } from 'react';

export default function usePromise<T>(buildPromise: () => Promise<T>) {
  const [promise, setPromise] = useState<Promise<T>>();

  useEffect(() => {
    setPromise(buildPromise() as any);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return promise;
}
